import { Component } from '@angular/core';
import { InstallNewBin } from '../install-new-bin/install-new-bin';

@Component({
  selector: 'app-swap-unit',
  imports: [InstallNewBin],
  templateUrl: './swap-unit.html',
  styleUrl: './swap-unit.scss',
})
export class SwapUnit {
  isSwap: any = true;

  constructor() {}

  ngOnInit() {
  }
}
